import React from 'react';
import { Handle, Position } from 'reactflow';

export default function PivotNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #ca8a04',
      background: 'var(--card)',
      minWidth: 210,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#eab308' }}>
        🎯 Pivot Point
      </div>

      <div style={{ display: 'flex', gap: 6 }}>
        <select
          value={data.timeframe || 'daily'}
          onChange={(e) => onChange('timeframe', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
        </select>
        <select
          value={data.level || 'pp'}
          onChange={(e) => onChange('level', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="pp">Pivot (PP)</option>
          <option value="r1">R1</option>
          <option value="r2">R2</option>
          <option value="r3">R3</option>
          <option value="s1">S1</option>
          <option value="s2">S2</option>
          <option value="s3">S3</option>
        </select>
      </div>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Classic floor pivot computed from the prior completed period's high/low/close. Outputs a price level — compare it against a price node.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#ca8a04' }} />
    </div>
  );
}
